module.exports = __webpack_public_path__ + "img/ic_weike.618ea814.svg";